/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo, useState } from "react";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_helpers";
import { Tooltip, withStyles, Fade } from "@material-ui/core";
import * as Version from "./version";
import { getBackendVersion } from "../../../../app/modules/Auth/_api";
import { useFetch } from "../../../../hooks/fetch.hook";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

export function Footer() {
  const { request } = useFetch();

  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const [loading, setLoading] = useState(false);
  const [backendVersion, setBackendVersion] = useState("");
  const frontendVersion = Version.frontendVersion
    ? Version.frontendVersion
    : "";

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true),
    };
  }, [uiService]);

  const fetchBackendVersion = () => {
    setLoading(true);
    request(getBackendVersion)
      .then((data) => {
        if (!data) return;
        setBackendVersion(
          `Last Backend Build ${data.build_time} [${data.commit_id}]`
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <div
      className={`footer py-4 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-dark order-2 order-md-1">
          Brismark &copy; <span className="mr-2">{today.toString()}</span>
        </div>
        <div className="order-1 order-md-2">
          <HtmlTooltip
            title={
              <div>
                {loading ? "Last Backend Build ... loading" : backendVersion}
                <br />
                <br />
                {frontendVersion}
              </div>
            }
            arrow
            interactive
            TransitionComponent={Fade}
            placement={"left"}
            enterDelay={500}
            leaveDelay={200}
            onOpen={fetchBackendVersion}
          >
            <a
              href="#"
              // target="_blank"
              // rel="noopener noreferrer"
              className="mr-3 pl-0"
            >
              <img
                src={toAbsoluteUrl("/assets/illuminance_labs_logo.png")}
                alt="illuminance-labs"
              />
            </a>
          </HtmlTooltip>
        </div>
      </div>
    </div>
  );
}

// echo "export const version_date = 'Last build: $(date -Iseconds)'" >> ./src/_metronic/layout/components/footer/Version.js
